import {
  dateTimeFormatter, settingActiveStatusFormatter, userFIOFormatter, userPositionFormatter,
} from '../../../utils/formatters';

export const settingsColumns = [
  {
    dataField: 'name',
    text: 'Название',
    headerClassName: 'name-column',
    disableSort: true,
  },
  {
    dataField: 'is_test',
    text: 'Среда',
    headerClassName: 'is-test-column',
    disableSort: true,
    formatter: item => (item ? 'Тестовая' : 'Продуктовая'),
  },
  {
    dataField: 'endpoint',
    text: 'Точка подключения',
    disableSort: true,
  },
  {
    dataField: 'is_active',
    text: 'Активен',
    headerClassName: 'is-active-column',
    disableSort: true,
    formatter: settingActiveStatusFormatter,
  },
  {
    dataField: 'author',
    text: 'Автор',
    headerClassName: 'author-column',
    disableSort: true,
    formatter: item => userPositionFormatter({ full_name: userFIOFormatter(item) }),
  },
  {
    dataField: 'created_at',
    text: 'Дата и время создания',
    headerClassName: 'date-column',
    formatter: dateTimeFormatter,
    disableSort: true,
  },
];
